import { EmptyCardComponent } from "designSystem/components/image/CsiImage";
import { CsiImage, GridRow, OverflowText } from "designSystem/index";
import { black, grey } from "designSystem/styles/color";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import { observer } from "mobx-react-lite";
import React from "react";
import { SlimCardStore } from "./SlimCardStore";

export interface SlimCardProperties {
	/* Whether an image should be displayed */
	displayImage: boolean;

	/* The source for the for the SlimCard object */
	slimCardStore: SlimCardStore;

	/* The color of the attribute combination and status label text */
	textColor?: string;
}

export const SlimCard = (props: SlimCardProperties) => {
	const { displayImage, slimCardStore, textColor = black[100] } = props;

	const { attributeCombination, imageSrc } = slimCardStore;

	return (
		<GridRow
			alignItems="center"
			flexWrap="nowrap"
			growChild={1}
			spacing={2}
		>
			{displayImage && (
				<CsiImage
					borderRadius={1}
					errorComponent={<EmptyCardComponent />}
					height={40}
					noImageComponent={<EmptyCardComponent />}
					src={imageSrc}
					sx={{
						border: STANDARD_BORDER_STYLE,
						borderColor: grey[200],
					}}
					width={40}
				/>
			)}
			<OverflowText 
				color={textColor} 
				text={attributeCombination} 
			/>
		</GridRow>
	);
};

export default observer(SlimCard);